export default "__VITE_ASSET__Cly0mEk1__"